import { css } from '@emotion/css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { EventHandler, FocusEvent } from 'react';
import DatePicker from 'react-datepicker';
import { FieldError } from 'react-hook-form';

import FormControlWrapper from './FormControlWrapper';

interface Props {
  value: Date;
  onChange: (data: Date | [Date, Date]) => void;
  renderCustomHeader?: (Params: {
    monthDate: Date;
    date: Date;
    changeYear(year: number): void;
    changeMonth(month: number): void;
    customHeaderCount: number;
    decreaseMonth(): void;
    increaseMonth(): void;
    prevMonthButtonDisabled: boolean;
    nextMonthButtonDisabled: boolean;
    decreaseYear(): void;
    increaseYear(): void;
    prevYearButtonDisabled: boolean;
    nextYearButtonDisabled: boolean;
  }) => React.ReactNode;
  dateFormat: string;
  placeholder: string;
  error: FieldError;
  disabled?: boolean;
  minDate?: Date;
  onBlur?: EventHandler<FocusEvent<any>>;
}

const popperClass = css({
  marginTop: '5px !important',
});

const container = css({
  position: 'relative',
});

const icon = css({
  position: 'absolute',
  top: '12px',
  right: '12px',
});

const FormDatePicker = ({
  value,
  onChange,
  dateFormat,
  placeholder,
  renderCustomHeader,
  disabled = false,
  error,
  minDate,
  onBlur,
}: Props) => (
  <FormControlWrapper labelVisible={!!value} error={error} label={placeholder}>
    {(_, errorClassName) => (
      <div className={container}>
        <DatePicker
          disabled={disabled}
          className={errorClassName}
          placeholderText={placeholder}
          onChange={date => onChange(date)}
          onBlur={onBlur}
          selected={value}
          popperClassName={popperClass}
          dateFormat={dateFormat}
          minDate={minDate}
          {...(renderCustomHeader ? { renderCustomHeader } : {})}
        />
        <div className={icon}>
          <FontAwesomeIcon icon={['far', 'calendar-alt']} />
        </div>
      </div>
    )}
  </FormControlWrapper>
);

export default FormDatePicker;
